import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { AppConstants } from '@apps/app.constants';
import { BaseMiscApiService } from '@common/api/base-misc-api.service';

import { ReportApi } from './models';
import { Report, ScheduleDescription, ShortRecipient } from '../domain/models';
import { UpdateReportApi } from '@apps/rept/api/view-models';

@Injectable({
    providedIn: 'root'
})
export class ReportsMiscApiService extends BaseMiscApiService
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlRept;
        this.segmentApi = '/rept/reports';
    }

    getReports (): Observable<ReportApi[]>
    {
        if (AppConstants.IsDataLocal('rept'))
        {
            return this.http.get<ReportApi[]>('assets/data/rept/TRV/reports.json');
        }

        return this.http.get<ReportApi[]>(`${this.segmentRoot}${this.segmentApi}`);
    }

    getReport (reportId: string): Observable<ReportApi>
    {
        return this.get<ReportApi>(`/${reportId}`);
    }

    createReport (report: Report): Observable<ReportApi>
    {
        return this.post<ReportApi>('', report);
    }

    nextSchedule (sd: ScheduleDescription): Observable<string>
    {
        return this.post<any>('/nextSchedule', sd);
    }

    updateReport (updateReport: UpdateReportApi): Observable<ReportApi>
    {
        return this.put<ReportApi>('/update', updateReport);
    }

    toggleActivationReport (reportId: string, toggle: boolean): Observable<ReportApi>
    {
        const action: string = toggle ? 'activate' : 'deactivate';

        return this.put<ReportApi>(`/${reportId}/${action}`, {});
    }

    deleteReport (reportId: string): Observable<ReportApi>
    {
        return this.put<ReportApi>(`/${reportId}/deactivate`, {});
    }

    addDefaultContractualReports (entityId: string)
    {
        return this.post<ReportApi[]>(`/contractuals/${entityId}`, {});
    }

    replayReport (reportId: string): Observable<boolean>
    {
        return this.put<boolean>(`/${reportId}/replay`, {});
    }
}
